import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  start_time: null,
  end_time: null,
  group_by: null,
  dateRangeItem: null,
  dateX: null,
  dateY: 'min',
  lastUpdate: new Date(),
  timezone: {
    abbrev: 'GMT',
    altName: 'British Standard Time',
    label: '(GMT+0:00) UTC',
    offset: 0,
    value: 'Etc/GMT',
  },
};

export const analyticSlices = createSlice({
  name: 'analyticSlices',
  initialState,
  reducers: {
    setDateRange(state, action) {
      const { start_time, end_time, group_by, dateRangeItem } = action.payload;

      state.start_time = start_time || state.start_time;
      state.end_time = end_time || state.end_time;
      state.group_by = group_by || state.group_by;
      state.dateRangeItem = dateRangeItem || state.dateRangeItem;
    },
    setLastUpdate(state, action) {
      const { lastUpdate } = action.payload;

      state.lastUpdate = lastUpdate || state.lastUpdate;
    },
    setTimezone(state, action) {
      const { timezone } = action.payload;

      state.timezone = timezone || state.timezone;
    },
    setDateRangeX(state, action) {
      const { dateX } = action.payload;

      state.dateX = dateX || state.dateX;
    },
    setDateRangeY(state, action) {
      const { dateY } = action.payload;

      state.dateY = dateY || state.dateY;
    },
  },
});

export const { setDateRangeX, setDateRangeY, setDateRange, setLastUpdate, setTimezone } =
  analyticSlices.actions;

export default analyticSlices.reducer;
